import styled from '@emotion/styled';
import React, { memo } from 'react';
import { useT } from 'client/i18n/hooks/useT';
import { MarketingImage } from 'components/MarketingPagesShared/MarketingImage';
import { BREAKPOINT_SMALL } from 'components/MarketingPagesShared/styles';
import {
  FeaturesCaptionedImage,
  FeaturesSection,
  FeaturesSectionDescription,
  FeaturesSectionSubtitle,
  FeaturesSectionTitle,
  FeaturesCaption,
} from '../../styles';

function FeaturesHostingSectionView() {
  const t = useT();
  return (
    <FeaturesSection>
      <FeaturesSectionTitle
        dangerouslySetInnerHTML={{
          __html: t(
            'FeaturesScreen.FeaturesHostingSection.Title',
            'Unlimited hosting,<br /> streamlined distribution',
            'Anchor features page hosting section title'
          ),
        }}
      />
      <FeaturesHostingGrid>
        <FeaturesCaptionedImage>
          <MarketingImage
            alt={t(
              'FeaturesScreen.FeaturesHostingSection.HostingImageAlt',
              'A woman on her laptop with a cloud icon on top of the image',
              'Anchor features page hosting image screenreader information'
            )}
            imagePath="features/hosting-free-unlimited"
            width={475}
            height={475}
          />
          <FeaturesCaption>
            <FeaturesSectionSubtitle>
              {t(
                'FeaturesScreen.FeaturesHostingSection.Subtitle',
                'Free, unlimited hosting',
                'Anchor features page hosting section subtitle'
              )}
            </FeaturesSectionSubtitle>
            <FeaturesSectionDescription>
              {t(
                'FeaturesScreen.FeaturesHostingSection.Description',
                'You own the rights to all of your content and can host unlimited episodes for free, always.',
                'Anchor features page hosting section description'
              )}
            </FeaturesSectionDescription>
          </FeaturesCaption>
        </FeaturesCaptionedImage>
        <FeaturesCaptionedImage>
          <MarketingImage
            alt={t(
              'FeaturesScreen.FeaturesHostingSection.DistributionImageAlt',
              'A photo of yellow and orange abstract art with the Spotify logo on the upper right hand corner',
              'Anchor features page distribution image screenreader information'
            )}
            imagePath="features/distribution-update-features"
            width={475}
            height={475}
          />
          <FeaturesCaption>
            <FeaturesSectionSubtitle>
              {t(
                'FeaturesScreen.FeaturesHostingSection.DistributionTitle',
                'Supported Distribution to all major listening apps',
                'Anchor features page distribution section title'
              )}
            </FeaturesSectionSubtitle>
            <FeaturesSectionDescription>
              {t(
                'FeaturesScreen.FeaturesHostingSection.DistributionDescription',
                'Reach a wider audience quickly and easily, including one-step distribution to Spotify.',
                'Anchor features page distribution section description'
              )}
            </FeaturesSectionDescription>
          </FeaturesCaption>
        </FeaturesCaptionedImage>
      </FeaturesHostingGrid>
    </FeaturesSection>
  );
}

export const FeaturesHostingSection = memo(FeaturesHostingSectionView);

const FeaturesHostingGrid = styled.div`
  display: grid;
  grid-gap: 20px;
  grid-template-columns: 1fr 1fr;

  @media (max-width: ${BREAKPOINT_SMALL}px) {
    grid-gap: 0;
    grid-template-columns: 1fr;
  }
`;
